import React, { useState, useEffect, useCallback } from "react";
import * as XLSX from "xlsx";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Button,
  ButtonGroup,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
// APi
import queryString from "query-string";
import Dataservices from "../../services/requestApi";
// core components
import Header from "components/Headers/Header";
import Loader from "components/loader/Loader";
import { Link } from "react-router-dom";
import moment from "moment";
import SearchViaDate from "components/Filter/SearchViaDate";
import { Pagination, Table, message } from "antd";
function AllDistributor() {
  const [AllUser, setAllUser] = useState([]);
  const [ready, setReady] = useState(false);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(undefined);
  const [toDate, setToDate] = useState(undefined);
  const [AllRank, setAllRank] = useState([]);
  const [pagination, setPagination] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal]= useState();
  const [password, setPassword] = useState("");
  const [isPasswordVerified, setIsPasswordVerified] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const verifyPassword = () => {
    // Assuming you have a function to verify the password
    if (password === "Shopers@123") { // Replace with your real check logic
      setIsPasswordVerified(true);
      setIsModalOpen(false);  // Close the modal upon successful verification
    } else {
      alert("Incorrect password");
    }
  };
  // getAllUSERS
  const getAllUSERS = useCallback(async (from, end, currentPage, pageSize, search) => {
    try {
      setReady(true);
      const res = await Dataservices.getAllDistributor(from, end, currentPage, pageSize, search, 'user');
      if (res.data?.message === "Success") {
        const user = res.data?.data;
        console.log(res.data?.data);
        const AllDistributor = [];
        for (let [index, val] of user.entries()) {
          // your code goes here
          val.UUID = ((currentPage-1)*10)+ index + 1;
          AllDistributor.push(val);
        }
        setAllUser(AllDistributor);
        setTotal(res.data?.total);
        // setTotalDist(res.data?.totalDistributors);
        // setTotalPage(res.data?.totalPages);
        setReady(false);
      }
    } catch (e) {
      console.log(e);
      setReady(false);
    }
  }, []);
  useEffect(() => {
    getAllUSERS(fromDate, toDate, currentPage, pageSize, search);
  }, [getAllUSERS]);

  const DistributorUpdate = async (e, id, MetaData, type) => {
    e.preventDefault();
    try {
      const Data = {};
      if (type === "rank") {
        Data.distributor_rank_id = MetaData;
      } else {
        Data.status = !MetaData;
      }
      const { data } = await Dataservices.updateDistributor(
        id,
        queryString.stringify(Data)
      );
      if (data) {
        message.success("Distributor updated successfully");
      }
      // window.location.reload(true);
    } catch (e) {
      console.log(e);
    }
  };
  // const searchFilter = AllUser.filter((data) => {
  //   const phone = data?.phone;
  //   const name = data?.name;
  //   const FunctionPhone = phone.toLowerCase().includes(search.toLowerCase());
  //   const FunctionName = name.toLowerCase().includes(search.toLowerCase());
  //   if (FunctionPhone) return FunctionPhone;
  //   if (FunctionName) return FunctionName;
  // });

  const SearchDate = async () => {
    if (fromDate && toDate) {
      getAllUSERS(fromDate, toDate, currentPage, pageSize, search);
    }
    if(search){
      getAllUSERS(fromDate, toDate, currentPage, pageSize, search);
    }
  };

  const handleTableChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    getAllUSERS(fromDate, toDate, page, pageSize, search);
  };

  const columns = [
    {
      title: "Sr no",
      dataIndex: "UUID",
      key: "UUID",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "Action_id",
      render: (id, item) => (
        <UncontrolledDropdown>
          <DropdownToggle
            className="btn-icon-only text-light"
            href="#pablo"
            role="button"
            size="sm"
            color=""
            onClick={(e) => e.preventDefault()}
          >
            <i className="fas fa-ellipsis-v" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-arrow" right>
            <DropdownItem
              to={{
                pathname: `update_distributor/${item?._id}`,
                state: item,
              }}
              tag={Link}
            >
              <i className="ni ni-settings text-danger" /> Update Profile
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ];

  const csvData = [
    [
      "Sr No.",
      "Name",
      "Phone",
      "Parent Name",
    ],
    ...AllUser?.map((item, idx) => [
      idx + 1,
      item?.name,
      item?.phone,
      item?.parent_id?.name ?? "NA",
    ]),
  ];
  // function OnPageChange(count) {
  //   setCurrentPage(count);
  //   getAllUSERS(fromDate, toDate, pageLimit, count);
  // }
  function ExportExcel() {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(csvData);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Use XLSX.writeFile to trigger the download
    XLSX.writeFile(wb, "Alldistributor.xlsx");
  }
  return (
    <>
      <Header show={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="shadow mt-5">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col lg="12">
                    <Row>
                      <Col>
                        <FormGroup className="mb-0">
                          <Label for="phoneSearch">
                            Search by phone or name
                          </Label>
                          <Input
                            className="form-control-alternative border shadow"
                            placeholder="Enter phone number or name"
                            id="phoneSearch"
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <SearchViaDate
                        fromDate={fromDate}
                        setFromDate={setFromDate}
                        toDate={toDate}
                        setToDate={setToDate}
                        action={SearchDate}
                      />
                    </Row>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <CSVLink
                  className="btn btn-outline-dark btn-sm"
                  filename="AllDistributor.csv"
                  data={csvData}
                >
                  Export CSV
                </CSVLink>
                <Button onClick={ExportExcel} outline size="sm" color="dark">
                  Export Excel
                </Button>
                <Table
                  columns={columns}
                  loading={ready}
                  dataSource={AllUser}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: total,
                    showSizeChanger: true,
                    onChange: (page, pageSize)=> {
                      handleTableChange(page, pageSize)
                    }
                  }}
                />
                {/* {searchFilter.length > 0 && (
                  <Pagination
                    responsive
                    current={currentpage}
                    onChange={OnPageChange}
                    total={totalDist}
                    pageSize={pageLimit}
                    showSizeChanger={false}
                    showTotal={(total) =>
                      `Total Distributor ${totalDist} items`
                    }
                  />
                )} */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AllDistributor;
